<app-reports-form [formModel]="model"></app-reports-form>